<!-- eslint-disable vue/no-v-html -->
<!-- skin-analysis-browserのSkinScoreRadarChart.vueと同じ内容 -->
<template>
  <div class="skin-score-radar-chart-component">
    <div class="legend-container">
      <div class="skin-score-radar-chart-your-data-legend-wrapper">
        <div class="skin-score-radar-chart-your-data-legend">
          <div class="skin-score-radar-chart-your-data-legend-ex"></div>
          <div
            class="skin-score-radar-chart-your-data-legend-label"
            v-html="$t('skinAnalysis.yourDataLabel')"
          ></div>
        </div>
      </div>
      <div
        v-if="averageData.length !== 0"
        class="skin-score-radar-chart-average-data-legend-wrapper"
      >
        <div class="skin-score-radar-chart-average-data-legend">
          <div class="skin-score-radar-chart-average-data-legend-ex"></div>
          <div
            class="skin-score-radar-chart-average-data-legend-label"
            v-html="$t('skinAnalysis.averageDataLabel')"
          ></div>
        </div>
      </div>
    </div>

    <div class="skin-analysis-radar-wrapper">
      <div class="firmness-label-item-wrapper">
        <div class="firmness-label-item label-item">
          <div
            class="firmness-label label-name"
            v-html="$t('skinAnalysis.labelsWithBr.firmness')"
          ></div>
          <div class="firmness-score label-score">{{ displayYourData(0) }}</div>
          <div v-if="previousYourData" class="firmness-arrow label-arrow">
            <div :class="decideArrowClass(0)"></div>
          </div>
        </div>
      </div>
      <div class="wrinkles-label-item-wrapper">
        <div class="wrinkles-label-item label-item">
          <div
            class="wrinkles-label label-name"
            v-html="$t('skinAnalysis.labelsWithBr.wrinkles')"
          ></div>
          <div class="wrinkles-score label-score">{{ displayYourData(1) }}</div>
          <div v-if="previousYourData" class="wrinkles-arrow label-arrow">
            <div :class="decideArrowClass(1)"></div>
          </div>
        </div>
      </div>
      <div class="darkCirclesV2-label-item-wrapper">
        <div class="darkCirclesV2-label-item label-item">
          <div
            class="darkCirclesV2-label label-name"
            v-html="
              `<div class='annotation-sub'>${$t('note_mark', {
                number: 1,
              })}</div>${$t('skinAnalysis.labelsWithBr.darkCirclesV2')}`
            "
          ></div>
          <div class="darkCirclesV2-score label-score">
            {{ displayYourData(2) }}
          </div>
          <div v-if="previousYourData" class="darkCirclesV2-arrow label-arrow">
            <div :class="decideArrowClass(2)"></div>
          </div>
        </div>
      </div>
      <div class="pore-label-item-wrapper">
        <div class="pore-label-item label-item">
          <div
            class="pore-label label-name"
            v-html="
              `${$t(
                'skinAnalysis.labels.pore'
              )}<sup class='annotation-sup'>${$t('note_mark', {
                number: 1,
              })}</sup>`
            "
          ></div>
          <div class="pore-score label-score">{{ displayYourData(3) }}</div>
          <div v-if="previousYourData" class="pore-arrow label-arrow">
            <div :class="decideArrowClass(3)"></div>
          </div>
        </div>
      </div>
      <div class="texture-label-item-wrapper">
        <div class="texture-label-item label-item">
          <div
            class="texture-label label-name"
            v-html="$t('skinAnalysis.labelsWithBr.texture')"
          ></div>
          <div class="texture-score label-score">{{ displayYourData(4) }}</div>
          <div v-if="previousYourData" class="texture-arrow label-arrow">
            <div :class="decideArrowClass(4)"></div>
          </div>
        </div>
      </div>
      <div class="ageSpots-label-item-wrapper">
        <div class="ageSpots-label-item label-item">
          <div
            class="ageSpots-label label-name"
            v-html="
              `<div class='annotation-sub'>${$t('note_mark', {
                number: 1,
              })}</div>${$t('skinAnalysis.labelsWithBr.ageSpots')}`
            "
          ></div>
          <div class="ageSpots-score label-score">{{ displayYourData(5) }}</div>
          <div v-if="previousYourData" class="ageSpots-arrow label-arrow">
            <div :class="decideArrowClass(5)"></div>
          </div>
        </div>
      </div>
      <div class="moisture-label-item-wrapper">
        <div class="moisture-label-item label-item">
          <div
            class="moisture-label label-name"
            v-html="$t('skinAnalysis.labelsWithBr.moisture')"
          ></div>
          <div class="moisture-score label-score">{{ displayYourData(6) }}</div>
          <div v-if="previousYourData" class="moisture-arrow label-arrow">
            <div :class="decideArrowClass(6)"></div>
          </div>
        </div>
      </div>
      <Radar
        id="skin-score-radar-chart"
        ref="radarChart"
        canvas
        :data="createChartData"
        :options="createChartOptions"
      />
      <!-- デバッグ用の背景色追加版 -->
      <!-- <Radar
        id="skin-score-radar-chart"
        ref="radarChart"
        canvas
        :data="createChartData"
        :options="createChartOptions"
        :plugins="createPlugins"
      /> -->
    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { Radar } from "vue-chartjs";
import colors from "../assets/colors";

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend
);

export default {
  components: {
    Radar,
  },
  props: {
    yourData: {
      type: Array,
      required: true,
    },
    averageData: {
      type: Array,
      required: true,
    },
    previousYourData: {
      type: Array,
      required: false,
      default: undefined,
    },
  },
  data() {
    return {
      chartElement: undefined,
    };
  },
  computed: {
    createChartData() {
      const data = {
        labels: [
          this.$t("skinAnalysis.labels.firmness"),
          this.$t("skinAnalysis.labels.wrinkles"),
          this.$t("skinAnalysis.labels.darkCirclesV2"),
          this.$t("skinAnalysis.labels.pore"),
          this.$t("skinAnalysis.labels.texture"),
          this.$t("skinAnalysis.labels.ageSpots"),
          this.$t("skinAnalysis.labels.moisture"),
        ],
        datasets: [
          {
            label: this.$t("skinAnalysis.averageDataLabel"),
            backgroundColor: "rgba(255,255,255,0)",
            borderColor: "rgba(255,99,132,1)",
            pointBorderColor: "rgba(255,255,255,0)",
            borderWidth: 2,
            borderDash: [10, 10],
            data: this.averageData,
          },
          {
            label: "yourDataLabel",
            backgroundColor: "rgba(136, 185, 197, 0.6)",
            borderColor: "rgba(0,0,0,0)",
            pointBackgroundColor: [
              colors.firmness_rgba,
              colors.wrinkles_rgba,
              colors.darkCirclesV2_rgba,
              colors.pore_rgba,
              colors.texture_rgba,
              colors.ageSpots_rgba,
              colors.moisture_rgba,
            ],
            data: this.yourData,
          },
        ],
      };
      if (!this.chartElement) {
        return data;
      }
      const radialGradient = this.createRadialGradient;
      if (radialGradient) {
        data.datasets[1].backgroundColor = radialGradient;
      }
      return data;
    },
    createChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          duration: 500, // アニメーションの継続時間（ミリ秒）
          easing: "linear", // アニメーションのイージング関数
        },
        layout: {
          padding: 75,
        },
        scales: {
          r: {
            min: 0,
            max: 100,
            ticks: {
              display: false,
              stepSize: 20, // 目盛間隔
            },
            grid: {
              circular: true, // 目盛り線を円形にする
            },
            angleLines: {
              color: "#DDDDDD",
              lineWidth: 2, // 縦軸の太さを設定
            },
            pointLabels: {
              display: false,
              font: {
                size: 14, // データラベルのフォントサイズを設定
              },
            },
          },
        },
        plugins: {
          legend: {
            display: false, // 凡例を非表示にする
          },
          customCanvasBackgroundColor: {
            color: "lightGreen",
          },
        },
        scaleLabel: {
          fontSize: 18,
        },
        onResize: this.updateChart,
      };
    },
    // デバッグ用の背景色追加
    createPlugins() {
      return [
        {
          id: "customCanvasBackgroundColor",
          beforeDraw: (chart, args, options) => {
            const { ctx } = chart;
            ctx.save();
            ctx.globalCompositeOperation = "destination-over";
            ctx.fillStyle = options.color || "#99ffff";
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
          },
        },
      ];
    },
  },
  created() {},
  mounted() {
    this.chartElement = document.getElementById("skin-score-radar-chart");
  },
  methods: {
    createRadialGradient() {
      if (this.chartElement == undefined) {
        return undefined;
      }
      const ctx = this.chartElement.getContext("2d");
      const chartWidth = this.chartElement.clientWidth;
      const chartHeight = this.chartElement.clientHeight;
      const centerX = chartWidth / 2;
      const centerY = chartHeight / 2;
      const radius = Math.min(centerX, centerY);
      // TODO: グラデーション表示の調整が必要(chartElementの領域が実際のグラフ外にも広がっている点に注意)
      const radialGradient = ctx.createRadialGradient(
        centerX,
        centerY,
        0,
        centerX,
        centerY,
        radius
      );
      radialGradient.addColorStop(0, "rgba(136, 185, 197, 0.2)");
      radialGradient.addColorStop(0.5, "rgba(136, 185, 197, 0.4)");
      radialGradient.addColorStop(0.8, "rgba(136, 185, 197, 0.6)");
      return radialGradient;
    },
    decideArrowClass(index) {
      if (!this.previousYourData) {
        return "";
      }
      if (this.yourData[index] > this.previousYourData[index]) {
        return "arrow-img arrow-up";
      }
      if (this.yourData[index] < this.previousYourData[index]) {
        return "arrow-img arrow-down";
      }
      if (this.yourData[index] === this.previousYourData[index]) {
        return "arrow-img arrow-right";
      }
      return "";
    },
    displayYourData(index) {
      const score = this.yourData[index];
      if (score === 0) {
        return "- - ";
      }
      return score;
    },
    updateChart() {
      if (this.$refs.radarChart && this.$refs.radarChart.chart) {
        this.$refs.radarChart.chart.update("none");
      }
    },
  },
};
</script>

<style scoped>
.skin-score-radar-chart-component {
  height: 100%;
  width: 100%;
}

.legend-container {
  height: 16px;
  width: 100%;
  position: relative;
}

.skin-score-radar-chart-your-data-legend-wrapper {
  height: 100%;
  width: 50%;
  position: absolute;
  top: 0px;
  left: 0px;
}

.skin-score-radar-chart-average-data-legend-wrapper {
  height: 100%;
  width: 50%;
  position: absolute;
  top: 0px;
  right: 0px;
}

.skin-score-radar-chart-your-data-legend {
  position: relative;
  height: 100%;
}
.skin-score-radar-chart-your-data-legend-ex {
  position: absolute;
  top: 0px;
  left: 25px;
  height: 16px;
  width: 26px;
  background: transparent linear-gradient(180deg, #88b9c599 0%, #88b9c533 100%)
    0% 0% no-repeat padding-box;
}
.skin-score-radar-chart-your-data-legend-label {
  position: absolute;
  top: 0px;
  left: 55px;
  height: 16px;
  text-align: center;
  font: normal normal 500 9px/11px Roboto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.skin-score-radar-chart-average-data-legend {
  position: relative;
  height: 100%;
}
.skin-score-radar-chart-average-data-legend-ex {
  position: absolute;
  top: 50%;
  left: calc(100% - 100px);
  transform: translate(0, -50%);
  height: 2px;
  width: 25px;
  background-image: linear-gradient(to right, #ff1100 4px, transparent 3px);
  background-size: 7px 2px;
  background-repeat: repeat-x;
  background-position: left center;
  opacity: 0.6;
}
.skin-score-radar-chart-average-data-legend-label {
  position: absolute;
  top: 0;
  left: calc(100% - 70px);
  height: 100%;
  font: normal normal 500 9px/11px Roboto;
  color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.skin-analysis-radar-wrapper {
  position: relative;
  width: 100vw;
  height: 100vw;
}

.skin-score-radar-chart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* ラベル 共通 */
.label-item {
  width: 75px;
  height: 75px;
  /* debug用の背景色 */
  /* background-color: rgba(136, 185, 197, 0.4); */
}
.label-name {
  text-align: center;
  font: normal normal normal 12px/17px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.label-score {
  height: 32px;
  display: flex;
  align-items: center;
  font: normal normal 300 24px/40px Roboto;
  letter-spacing: 0px;
  color: #000000;
}
.label-arrow {
  height: 22px;
  width: 22px;
}
.arrow-img {
  height: 100%;
  width: 100%;
  background-size: contain;
}
.arrow-up {
  background-image: url("../assets/images/icon_arrow_up_line.png");
}
.arrow-down {
  background-image: url("../assets/images/icon_arrow_down_line.png");
}
.arrow-right {
  background-image: url("../assets/images/icon_arrow_line.png");
}
.label-item :deep(.annotation-sub) {
  vertical-align: sub;
  text-align: left;
  font: normal normal normal 8px/17px Noto Sans JP;
  color: #000000;
  opacity: 0.6;
}
.label-item :deep(.annotation-sup) {
  vertical-align: super;
  font: normal normal normal 8px/17px Noto Sans JP;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.6;
  margin-left: 2px;
}

/* ハリ ラベル */
.firmness-label-item-wrapper {
  position: absolute;
  top: 90px;
  left: 50%;
  transform: translate(-50%, -100%);
}
.firmness-label-item {
  position: relative;
}
.firmness-label {
  position: absolute;
  top: 17%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.firmness-score {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.firmness-arrow {
  position: absolute;
  top: 48%;
  left: 90%;
  transform: translate(-50%, -50%);
}

/* 乾燥小じわ ラベル */
.wrinkles-label-item-wrapper {
  position: absolute;
  top: 25%;
  left: 82%;
  transform: translate(-50%, -50%);
}
.wrinkles-label-item {
  position: relative;
}
.wrinkles-label {
  position: absolute;
  top: 17%;
  left: 50%;
  transform: translate(-50%, -50%);

  white-space: nowrap;
}
.wrinkles-score {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.wrinkles-arrow {
  position: absolute;
  top: 48%;
  left: 90%;
  transform: translate(-50%, -50%);
}

/* 目もとの明るさ ラベル */
.darkCirclesV2-label-item-wrapper {
  position: absolute;
  top: 63%;
  left: 90%;
  transform: translate(-50%, -50%);
}
.darkCirclesV2-label-item {
  position: relative;
}
.darkCirclesV2-label {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}
.darkCirclesV2-score {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.darkCirclesV2-arrow {
  position: absolute;
  top: 55%;
  left: 90%;
  transform: translate(-50%, -50%);
}

/* 毛穴の目立ち ラベル */
.pore-label-item-wrapper {
  position: absolute;
  top: 89%;
  left: 70%;
  transform: translate(-50%, -50%);
}
.pore-label-item {
  position: relative;
}
.pore-label {
  position: absolute;
  top: 49%;
  left: 58%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}
.pore-score {
  position: absolute;
  top: 17%;
  left: 48%;
  transform: translate(-50%, -50%);
}
.pore-arrow {
  position: absolute;
  top: 17%;
  left: 90%;
  transform: translate(-50%, -50%);
}

/* なめらかさ ラベル */
.texture-label-item-wrapper {
  position: absolute;
  top: 89%;
  left: 32%;
  transform: translate(-50%, -50%);
}
.texture-label-item {
  position: relative;
}
.texture-label {
  position: absolute;
  top: 53%;
  left: 48%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}
.texture-score {
  position: absolute;
  top: 17%;
  left: 48%;
  transform: translate(-50%, -50%);
}
.texture-arrow {
  position: absolute;
  top: 15%;
  left: 10%;
  transform: translate(-50%, -50%);
}

/* 肌全体の明るさ ラベル */
.ageSpots-label-item-wrapper {
  position: absolute;
  top: 63%;
  left: 10%;
  transform: translate(-50%, -50%);
}
.ageSpots-label-item {
  position: relative;
}
.ageSpots-label {
  position: absolute;
  top: 0%;
  left: 48%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}
.ageSpots-score {
  position: absolute;
  top: 57%;
  left: 48%;
  transform: translate(-50%, -50%);
}
.ageSpots-arrow {
  position: absolute;
  top: 57%;
  left: 10%;
  transform: translate(-50%, -50%);
}

/* うるおい ラベル */
.moisture-label-item-wrapper {
  position: absolute;
  top: 26%;
  left: 20%;
  transform: translate(-50%, -50%);
}
.moisture-label-item {
  position: relative;
}
.moisture-label {
  position: absolute;
  top: 25%;
  left: 48%;
  transform: translate(-50%, -50%);
  white-space: nowrap;
}
.moisture-score {
  position: absolute;
  top: 57%;
  left: 48%;
  transform: translate(-50%, -50%);
}
.moisture-arrow {
  position: absolute;
  top: 55%;
  left: 10%;
  transform: translate(-50%, -50%);
}
</style>
